module.exports = __webpack_public_path__ + "img/success-with-dg-woodpacking.644c9fb3.svg";